import React from 'react'
import { Link } from 'react-router-dom'

const Register = () => {
  return (
    <section className="register-section">
    <div className="auto-container">
      <div className="row clearfix">
        {/*Form Column*/}
        <div className="form-column column col-lg-6 col-md-12 col-sm-12">
          <div className="sec-title">
            <h2>Join</h2>
            <div className="separate" />
          </div>
          {/*Login Form*/}
          <div className="styled-form login-form">
            <form
              method="post"
              action="https://themecraze.net/html/volia/index.html"
            >
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-user" />
                </span>
                <input
                  type="text"
                  name="username"
                  defaultValue=""
                  placeholder="Your Name *"
                />
              </div>
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-envelope" />
                </span>
                <input
                  type="email"
                  name="useremil"
                  defaultValue=""
                  placeholder="Emai Address*"
                />
              </div>
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-unlock-alt" />
                </span>
                <input
                  type="password"
                  name="userpassword"
                  defaultValue=""
                  placeholder="Enter Password"
                />
              </div>
              <div className="clearfix">
                <div className="form-group pull-left">
                  <button type="button" className="theme-btn btn-style-one">
                    <span className="btn-title">Login Now</span>
                  </button>
                </div>
                <div className="form-group social-links-two pull-right">
                  Or login with
                  <Link  to="#" className="img-circle facebook">
                    <span className="fab fa-facebook-f" />
                  </Link> 
                  <Link  to="#" className="img-circle twitter">
                    <span className="fab fa-twitter" />
                  </Link> 
                  <Link  to="#" className="img-circle google-plus">
                    <span className="fab fa-google-plus" />
                  </Link> 
                </div>
              </div>
              <div className="clearfix">
                <div className="pull-left">
                  <input type="checkbox" id="remember-me" />
                  <label className="remember-me" htmlFor="remember-me">
                    &nbsp; Remember Me
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/*Form Column*/}
        <div className="form-column column col-lg-6 col-md-12 col-sm-12">
          <div className="sec-title">
            <h2>Register Here</h2>
            <div className="separate" />
          </div>
          {/*Login Form*/}
          <div className="styled-form register-form">
            <form
              method="post"
              action="https://themecraze.net/html/volia/index.html"
            >
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-user" />
                </span>
                <input
                  type="text"
                  name="username"
                  defaultValue=""
                  placeholder="Your Name *"
                />
              </div>
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-envelope" />
                </span>
                <input
                  type="email"
                  name="useremil"
                  defaultValue=""
                  placeholder="Emai Address*"
                />
              </div>
              <div className="form-group">
                <span className="adon-icon">
                  <span className="fa fa-unlock-alt" />
                </span>
                <input
                  type="password"
                  name="userpassword"
                  defaultValue=""
                  placeholder="Enter Password"
                />
              </div>
              <div className="clearfix">
                <div className="form-group pull-left">
                  <button type="button" className="theme-btn btn-style-one">
                    <span className="btn-title">Join here</span>
                  </button>
                </div>
                <div className="form-group submit-text pull-right">
                  * You must be a free registered to submit content.
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Register